import { render, staticRenderFns } from "./RecordConfigurator.vue?vue&type=template&id=49ab3e57&scoped=true&"
import script from "./RecordConfigurator.vue?vue&type=script&lang=js&"
export * from "./RecordConfigurator.vue?vue&type=script&lang=js&"
import style0 from "./RecordConfigurator.vue?vue&type=style&index=0&id=49ab3e57&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49ab3e57",
  null
  
)

export default component.exports